import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Box, Pagination, Chip } from '@mui/material';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom';
import '../../styles/Service.scss';
import '../../styles/App.scss';
import SearchAndButtonTab from '../../component/ui/SearchAndButtonTab';
import { VIEW_INVOICE } from '../../component/common/Routes/AppRoutes';
import { formatDateWithAmPm, columnFetcher } from '../../Style';
import ReusableTable from '../../component/ui/ReusableTable';
import { VENDOR_VIEW_INVOICE } from '../../component/common/Routes/VendorRoutes';
import { CUSTOMER_VIEW_INVOICE } from '../../component/common/Routes/CustomerRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import Logo from '../../assets/Atithiseva-Logo-Final-1024x298.png';
import { fetchBookingRequest } from '../../redux/Bookings/BookingAction';
import { fetchAllInvoicesRequest } from '../../redux/Invoice/InvoiceAction';

const ViewPaymentList = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const payments = useSelector((state) => state?.Invoice?.invoices);

  const paymentDetails = useSelector((state) => state.booking?.booking?.data);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchColumn, setSearchColumn] = useState('pnr_number');
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const navigate = useNavigate();
  console.log('payments', payments);

  useEffect(() => {
    dispatch(fetchAllInvoicesRequest());
    dispatch(fetchBookingRequest('34a457f2-f9bc-475f-8bfc-0b62299b03c6'));
  }, []);
  const currencyFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
  });

  const handleDownloadPDF = (paymentDetails) => {
    const doc = new jsPDF();

    const primaryColor = [237, 125, 49];
    const textColor = [50, 50, 50];
    const lightGray = [245, 245, 245];
    const lightOrange = [252, 235, 218];

    const rupeePrefix = 'Rs.';

    // Setup header and styling
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, 210, 40, 'F');
    doc.setFillColor(247, 150, 70);
    doc.rect(0, 40, 210, 2, 'F');

    if (Logo) {
      doc.addImage(Logo, 'PNG', 15, 10, 40, 17);
    }

    // Invoice title and number
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(22);
    doc.setTextColor(255, 255, 255);
    doc.text('INVOICE', 195, 20, { align: 'right' });

    doc.setFontSize(10);
    doc.text(
      `#${paymentDetails?.booking_serial_no || 'INV-2024001'}`,
      195,
      27,
      {
        align: 'right',
      }
    );

    doc.text(
      `Date: ${formatDateWithAmPm(paymentDetails?.created_at)}`,
      195,
      34,
      { align: 'right' }
    );

    // From details (company info)
    doc.setFontSize(11);
    doc.setTextColor(...textColor);
    doc.setFont('helvetica', 'bold');
    doc.text('FROM:', 15, 55);
    doc.setFont('helvetica', 'normal');
    doc.text('Your Company Name', 15, 62);
    doc.text('Company Address Line 1', 15, 69);
    doc.text('City, State, ZIP', 15, 76);
    doc.text('GSTIN: 29ABCDE1234F1Z5', 15, 83);
    doc.text('contact@yourcompany.com', 15, 90);

    // Billed to (customer info)
    doc.setFont('helvetica', 'bold');
    doc.text('BILLED TO:', 150, 55);
    doc.setFont('helvetica', 'normal');

    // Use customer data from BillingAddress if available
    const customerName = paymentDetails?.BillingAddress
      ? `${paymentDetails?.BillingAddress?.first_name} ${paymentDetails?.BillingAddress?.last_name}`
      : 'Customer Name';

    const companyName =
      paymentDetails?.BillingAddress?.company_name || 'Company Name';
    const customerEmail =
      paymentDetails?.BillingAddress?.email || 'customer@email.com';

    doc.text(customerName, 150, 62);
    doc.text(companyName, 150, 69);

    // Use address if available, otherwise default text
    if (paymentDetails.BillingAddress) {
      doc.text(paymentDetails.BillingAddress.address_line_1 || '', 150, 76);
      doc.text(
        `PIN: ${paymentDetails.BillingAddress.zipcode || '000000'}, ${
          paymentDetails.BillingAddress.country || 'India'
        }`,
        150,
        83
      );
    } else {
      doc.text('Address, and City Name', 150, 76);
      doc.text('PIN: 560001, India', 150, 83);
    }

    doc.text(customerEmail, 150, 90);

    // Service table header
    doc.setFillColor(...lightOrange);
    doc.roundedRect(15, 100, 180, 10, 1, 1, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...textColor);

    // Define column widths and positions
    const columnWidths = {
      airport: 40, // Width for Airport column
      service: 50, // Width for Service column
      price: 35, // Width for PRICE column
      total: 35, // Width for TOTAL column
    };

    const columnPositions = {
      airport: 20,
      service: 20 + columnWidths.airport + 5,
      price: 20 + columnWidths.airport + columnWidths.service + 10,
      total: 185,
    };

    // Draw column headers with fixed positions
    doc.text('Airport', columnPositions.airport, 107);
    doc.text('Service', columnPositions.service, 107);
    doc.text('PRICE', columnPositions.price, 107);
    doc.text('TOTAL', columnPositions.total, 107, { align: 'right' });

    // Service items
    doc.setFont('helvetica', 'normal');
    let y = 117;

    const items = [
      {
        airport: paymentDetails.airport_name || 'Airport',
        services: paymentDetails.Service?.services || 'Service',
        price: paymentDetails.Order?.sub_total || 0,
        total: paymentDetails.Order?.sub_total || 0,
      },
    ];

    const formatCurrency = (amount) => {
      return `${rupeePrefix} ${parseFloat(amount).toFixed(2)}`;
    };

    // Draw service items with text wrapping for longer content
    items.forEach((item, index) => {
      if (index % 2 === 1) {
        doc.setFillColor(...lightGray);
        doc.rect(15, y - 5, 180, 10, 'F');
      }

      // Handle text wrapping for longer content
      const airportText = doc.splitTextToSize(
        item.airport,
        columnWidths.airport
      );
      const serviceText = doc.splitTextToSize(
        item.services,
        columnWidths.service
      );

      // Calculate height needed based on which text is longer
      const lineHeight = 7;
      const airportLines = airportText.length;
      const serviceLines = serviceText.length;
      const maxLines = Math.max(airportLines, serviceLines, 1);
      const rowHeight = maxLines * lineHeight;

      // Draw background for multi-line rows if needed
      if (maxLines > 1 && index % 2 === 1) {
        doc.setFillColor(...lightGray);
        doc.rect(15, y - 5, 180, rowHeight, 'F');
      }

      // Position each text element
      doc.text(airportText, columnPositions.airport, y);
      doc.text(serviceText, columnPositions.service, y);
      doc.text(formatCurrency(item.price), columnPositions.price, y);
      doc.text(formatCurrency(item.total), columnPositions.total, y, {
        align: 'right',
      });

      // Increment y by the height of this row
      y += Math.max(rowHeight, 10);
    });

    // Line separating items from totals
    y += 5;
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(15, y, 195, y);

    // Calculate totals
    const subtotal = paymentDetails.Order?.sub_total || 0;
    const discountPercentage = paymentDetails.Order?.discount || 10;
    const discountAmount = (subtotal * discountPercentage) / 100;
    const cgstRate = 9;
    const sgstRate = 9;
    const cgstAmount = ((subtotal - discountAmount) * cgstRate) / 100;
    const sgstAmount = ((subtotal - discountAmount) * sgstRate) / 100;
    const grandTotal = subtotal - discountAmount + cgstAmount + sgstAmount;

    // Draw totals
    y += 10;
    doc.text('Sub Total', 120, y);
    doc.text(formatCurrency(subtotal), 185, y, { align: 'right' });

    y += 10;
    doc.text(`Discount (${discountPercentage}%)`, 120, y);
    doc.text(formatCurrency(discountAmount), 185, y, { align: 'right' });

    y += 10;
    doc.text(`CGST (${cgstRate}%)`, 120, y);
    doc.text(formatCurrency(cgstAmount), 185, y, { align: 'right' });

    y += 10;
    doc.text(`SGST (${sgstRate}%)`, 120, y);
    doc.text(formatCurrency(sgstAmount), 185, y, { align: 'right' });

    // Draw grand total
    y += 15;
    doc.setFillColor(...primaryColor);
    doc.roundedRect(120, y - 5, 75, 15, 2, 2, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.text('TOTAL', 130, y + 3);
    doc.setFontSize(12);
    doc.text(formatCurrency(grandTotal), 185, y + 3, { align: 'right' });

    // Terms and conditions section
    const footerY = 280;
    const termsStartY = footerY - 40;
    doc.setFillColor(...lightOrange);
    doc.roundedRect(15, termsStartY, 180, 7, 1, 1, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...textColor);
    doc.text('TERMS & CONDITIONS', 105, termsStartY + 5, { align: 'center' });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.text(
      '1. Payment is due within 15 days of invoice date.',
      15,
      termsStartY + 15
    );
    doc.text(
      '2. All services are subject to our standard terms available at www.yourcompany.com/terms',
      15,
      termsStartY + 22
    );
    doc.text(
      '3. Please include the invoice number in all payment references.',
      15,
      termsStartY + 29
    );

    // Footer
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('Thank you for your business!', 105, footerY + 5, {
      align: 'center',
    });
    doc.setDrawColor(...primaryColor);
    doc.line(15, footerY, 195, footerY);
    doc.text(
      'www.yourcompany.com | +91 9876543210 | contact@yourcompany.com',
      105,
      footerY + 10,
      { align: 'center' }
    );

    doc.save(
      `Invoice-${
        paymentDetails.booking_serial_no ||
        paymentDetails.pnr_number ||
        'INV-2024001'
      }.pdf`
    );
  };

  const handleExport = () => {
    const csvHeaders = [
      'Payment Id, Booking Id, Payment Date And Time, Payment Method, Price, CGST, SGST, Total, Payment Status',
    ];

    const csvRows = payments.map((payment) =>
      [
        payment?.pnr_number,
        payment?.booking_serial_no,
        payment?.created_at,
        'UPI', // Static payment method
        // Price from vendorBookLogs or Order
        payment?.vendorBookLogs?.length > 0
          ? payment?.vendorBookLogs[0]?.price
          : payment?.Order?.price,
        // CGST from vendorBookLogs or Order
        payment?.vendorBookLogs?.length > 0
          ? payment?.vendorBookLogs[0]?.cgst
          : payment?.Order?.cgst,
        // SGST from vendorBookLogs or Order
        payment?.vendorBookLogs?.length > 0
          ? payment?.vendorBookLogs[0]?.sgst
          : payment?.Order?.sgst,
        // Total from vendorBookLogs, total_amount, or Order
        payment?.vendorBookLogs?.length > 0
          ? payment?.vendorBookLogs[0]?.total
          : payment?.total_amount || payment?.Order?.total,
        // Payment status
        payment?.payment_status === 1
          ? 'Completed'
          : payment?.payment_status === 2
          ? 'Pending'
          : 'Rejected',
      ].join(', ')
    );
    const csvContent = [csvHeaders, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'payments.csv');
  };

  const filteredPayments = payments.filter((payment) =>
    payment[searchColumn]?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  console.log('fileterdPayments', filteredPayments);
  const paginatedPayments = filteredPayments.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleView = (payment) => {
    let viewRoute;

    if (user.role === 'Admin') {
      viewRoute = VIEW_INVOICE;
    } else if (user.role === 'Vendor') {
      viewRoute = VENDOR_VIEW_INVOICE;
    } else if (user.role === 'Customer') {
      viewRoute = CUSTOMER_VIEW_INVOICE;
    }
    navigate(viewRoute, {
      state: { invoiceId: payment?.BookingDetail?.booking_id },
    });
  };

  const columns = [
    { field: 'pnr_number', header: 'Payment Id' },
    { field: 'booking_serial_no', header: 'Booking Id' },
    {
      field: 'created_at',
      header: 'Payment Date',
      render: (value) => formatDateWithAmPm(value),
    },
    {
      field: 'payment_method',
      header: 'Payment Method',
      render: () => 'UPI', // Static value
    },
    {
      field: 'price',
      header: 'Price',
      render: (value, row) => {
        const price =
          row.vendorBookLogs?.length > 0
            ? row.vendorBookLogs[0]?.price
            : row.Order?.price;
        return currencyFormatter.format(price || 0);
      },
    },
    {
      field: 'cgst',
      header: 'CGST',
      render: (value, row) => {
        const cgst =
          row.vendorBookLogs?.length > 0
            ? row.vendorBookLogs[0]?.cgst
            : row.Order?.cgst;
        return currencyFormatter.format(cgst || 0);
      },
    },
    {
      field: 'sgst',
      header: 'SGST',
      render: (value, row) => {
        const sgst =
          row.vendorBookLogs?.length > 0
            ? row.vendorBookLogs[0]?.sgst
            : row.Order?.sgst;
        return currencyFormatter.format(sgst || 0);
      },
    },
    {
      field: 'total_amount',
      header: 'Total',
      render: (value, row) => {
        const total =
          row.vendorBookLogs?.length > 0
            ? row.vendorBookLogs[0]?.total
            : row.total_amount || row.Order?.total;
        return currencyFormatter.format(total || 0);
      },
    },
    {
      field: 'payment_status',
      header: 'Payment Status',
      render: (value) => {
        let color = 'default';
        if (value === 1) color = 'success';
        else if (value === 2) color = 'warning';
        else if (value === 3) color = 'error';
        return (
          <Chip
            label={
              value === 1 ? 'Completed' : value === 2 ? 'Pending' : 'Rejected'
            }
            color={color}
            size='small'
          />
        );
      },
    },
  ];
  return (
    <Box className='container'>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <SearchAndButtonTab
                title={'Invoices'}
                columns={columnFetcher(payments)}
                searchColumn={searchColumn}
                setSearchColumn={setSearchColumn}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                handleExport={handleExport}
              />

              <ReusableTable
                data={payments}
                columns={columns}
                headers={columns}
                paginatedData={paginatedPayments}
                handleView={handleView}
                pdfData={paymentDetails}
                handleDownloadPDF={handleDownloadPDF}
              />

              <Box mt={2} display='flex' justifyContent='end'>
                <Pagination
                  count={Math.ceil(filteredPayments.length / rowsPerPage)}
                  page={page}
                  onChange={handlePageChange}
                  color='primary'
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ViewPaymentList;
